import {inject, Injectable} from '@angular/core';
import {HttpBackend, HttpClient} from '@angular/common/http';
import {forkJoin, tap} from 'rxjs';
import Ajv2020 from 'ajv/dist/2020';
import {JTDSchemaType} from 'ajv/dist/types/jtd-schema';
import { Configuration } from 'src/configuration/configuration.type';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {

  private configuration: Configuration;
  private httpClient: HttpClient;

  constructor(private handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
  }

  load() {
    return forkJoin([
      this.httpClient.get<JTDSchemaType<Configuration>>('configuration-schema-definition.json'),
      this.httpClient.get<Object>('configuration.json'),
    ]).pipe(
      tap(([schemaDefinition, configuration]) => {
        const ajv = new Ajv2020();
        const validateSchema = ajv.compile(schemaDefinition);
        if (!validateSchema(configuration)) {
          console.error('Configuration validation failed:', validateSchema.errors);
          throw new Error('Invalid configuration format');
        }

        this.configuration = configuration as Configuration;
      }),
    );
  }

  get(): Configuration {
    if (!this.configuration) {
      throw new Error('Configuration not loaded yet. Please ensure load() is called before accessing configuration.');
    }
    return this.configuration;
  }
}
